import Typography from '@material-ui/core/Typography'
import Button from 'lib/ui/Button'
import Center from 'lib/ui/layout/Center'
import React from 'react'
import styled from 'styled-components'

export interface RedirectErrorMessageProps {
  status?: number
  onRetry: () => void
}

export default function RedirectErrorMessage(props: RedirectErrorMessageProps) {
  const {status, onRetry} = props

  if (status === 404) {
    return (
      <Center>
        <Typography align="center">
          This link is not active. Contact the event organizer.
        </Typography>
      </Center>
    )
  }

  if (status === 429) {
    return (
      <Center>
        <Typography align="center">
          Too many attempts. Wait a minute and try again.
        </Typography>
      </Center>
    )
  }

  return (
    <Center>
      <div>
        <Typography align="center">
          Could not open the AI Hub. Try again.
        </Typography>
        <RetryButton
          variant="contained"
          color="primary"
          aria-label="retry"
          onClick={onRetry}
        >
          Retry
        </RetryButton>
      </div>
    </Center>
  )
}

const RetryButton = styled(Button)`
  margin-top: ${(props) => props.theme.spacing[4]};
`
